export interface RepeatDaysDto
{
    getTitle():string;
    getIsSelected():boolean;
}

export class RepeatDaysDtoImpl implements RepeatDaysDto
{
    private title: string;
    private isSelected: boolean;
    

    setTitle(title: string)
    {
        this.title = title;
    }
    getTitle(): string 
    {
        return this.title;
    } 

    setIsSelected(isSelected: boolean)
    {
        this.isSelected = isSelected;
    }
    getIsSelected(): boolean 
    {
        return this.isSelected;
    } 

  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/repeatdaysdto/repeatdaysdto.ts